import {Aggregation, AggregationOption, SortFields} from '@/__generated__/__types__';
import {PageType} from '@/_application/core/types';
import {disabledAttributes} from '@/framework/static/filter-attribute-code-value-type';
import {disabledSortFields} from '@/framework/static/sort-fields';

export const getAllowedAttributesListByPage = (page: PageType) => {
    switch (page) {
        case PageType.BRAND:
            return ['category_id'];
        case PageType.CATEGORY:
            return [];
        default:
            return [];
    }
};

export const getDisallowedAttributes = (allowedAttributes: string[], disabledAttributes: string[]) => {
    if (!allowedAttributes.length) {
        return disabledAttributes;
    }
    return disabledAttributes.filter(item => !allowedAttributes?.includes(item));
};

export const getValidAggregationList = (aggregations: Aggregation[], page: PageType) => {
    if (!aggregations.length) {
        return [];
    }
    const allowedAttributes = page ? getAllowedAttributesListByPage(page) : [];
    const disallowedAttributes = getDisallowedAttributes(allowedAttributes, disabledAttributes);
    return aggregations.filter(item => !disallowedAttributes.includes(item.attribute_code));
};

export const getValidSortField = (sortFields: SortFields) => {
    if (!sortFields.options?.length) {
        return {} as SortFields;
    }
    const validOptions = sortFields?.options?.filter(option => !disabledSortFields.includes(option?.value ?? ''));
    return {...sortFields, options: validOptions} as SortFields;
};

export const getPriceRangeByAggregationOption = (value: AggregationOption[], chosenPrice: 'min' | 'max'): number => {
    // value is readonly, clone another array to use sort fn
    const aggregations = [...value];
    aggregations.sort((a, b) => Number.parseInt(a.value, 10) - Number.parseInt(b.value, 10));
    switch (chosenPrice) {
        case 'min': {
            const minValue: number = Number.parseInt(aggregations?.[0]?.value ?? 0, 10);
            // Prevent value return NaN => Set default value = 0
            return Number.isFinite(minValue) ? minValue : 0;
        }

        case 'max': {
            const adjustedValue = 100000;
            const maxValue: number = Number.parseInt(aggregations?.[aggregations?.length - 1]?.value ?? 0, 10);
            return (Number.isFinite(maxValue) ? maxValue : 0) + adjustedValue;
        }
    }
};

export const getUniqueAggregation = (aggregations: Aggregation[]) => {
    const aggregationsMapIterator = new Map(
        aggregations?.map(aggregation => [aggregation?.attribute_code, aggregation]),
    ).values();
    return Array.from(aggregationsMapIterator);
};
